import { useEffect, useState } from "react";
import { useModalForm } from "../../../../../utils/hooks/useModalForm";
import PendingSearch from "./PendingSearch";

const Pending = (props) => {
  const isAdmin = props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
  const [isFetching, setIsFetching] = useState(true);
  const [search, setSearch] = useState({
    page: 1,
    // limit: 10,
  });
  const [rowcount, setRowcount] = useState(0);
  const [applId, setApplId] = useState(null);
  const [data, setData] = useState([]);
  const columns = [
    {
      dataIndex: "created_by",
      title: "Connector Name",
      render: (text, record) => {
        return (
          <span className="table-primary-text">
            {record?.created_by?.full_name}
          </span>
        );
      },
      display: isAdmin ? true : false,
    },
    {
      dataIndex: "created_by",
      title: "Connector Mobile No.",
      render: (text, record) => {
        return (
          <span className="table-primary-text">
            {record?.created_by?.mobile_number}
          </span>
        );
      },
      display: isAdmin ? true : false,
    },
    {
      dataIndex: "borrower_full_name",
      title: "Customer Name",
      render: (text, record) => {
        return <span className="table-primary-text">{text}</span>;
      },
    },
    {
      dataIndex: "borrower_mobile_number",
      title: "Customer Mobile No.",
      render: (text, record) => {
        return <span className="table-primary-text">{text}</span>;
      },
    },
    {
      dataIndex: "application_number",
      title: "Application No.",
    },
    {
      dataIndex: "created_by",
      title: "Bank Name",
      render: (text, record) => {
        let bankName =
          record?.created_by?.bank_details?.bank_account_holder_bank_name;
        return <>{bankName || "-"}</>;
      },
    },
    {
      dataIndex: "loan_disbursed_amount",
      title: "Disb. Amt.",
      render: (text) => {
        return <>{text?.cur(0) || "-"}</>;
      },
    },
    {
      dataIndex: "loan_disbursement_date",
      title: "Disb. Date",
      render: (text, record) => {
        if (record?.loan_disbursement_date) {
          let date = new Date(text).dateToDDMMYYYY(new Date(text));
          return date;
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "application_status",
      title: "Application Status",
      render: (text) => {
        return (
          <AppTag color={_enum.STATUS_COLOR_MAP[text.toLowerCase()]}>
            {text?.toTitleCase() || "-"}
          </AppTag>
        );
      },
    },
  ];
  // ----------------------------------------------------------------

  const modalConfigs = {
    applicationLoan: [
      {
        name: "borrower_full_name",
        label: "Customer Name",
        type: "text",
        required: true,
      },
      {
        name: "borrower_mobile_number",
        label: "Mobile No.",
        type: "text",
        rules: _enum.MOBILE_NUM_RULE,
        required: true,
      },
      {
        name: "application_product_type",
        label: "Product Type",
        type: "select",
        fetchOptions: () => props.apis.apiGetProductTypes(),
        required: true,
      },
      {
        name: "lender_bank_name",
        label: "Bank Name",
        type: "select",
        options: [],
        fetchOptions: () => props.apis.apiGetBanknames(),
        required: true,
      },
      {
        name: "application_number",
        label: "Application No.",
        type: "text",
        required: true,
      },
      {
        name: "application_status",
        label: "Application Status",
        type: "select",
        options: _enum.APPLICATION_STATUS,
        disabled: true,
      },
      {
        name: "loan_disbursed_amount",
        label: "Disb. Amount",
        type: "number",
        required: true,
      },
      {
        name: "loan_disbursement_date",
        label: "Disb. Date",
        type: "date",
        required: true,
      },
    ],
    payoutInfo: [
      {
        type: "section",
        label: "Loan Info:",
        divider: false,
        colspan: 24,
        align: "end",
      },
      { type: "empty", colspan: 24 },
      {
        name: "borrower_full_name",
        label: "Connector Name",
        type: "text",
        readOnly: true,
      },
      {
        name: "borrower_mobile_number",
        label: "Connector Mobile No.",
        type: "text",
        readOnly: true,
      },
      {
        name: "customer_name",
        label: "Customer Name",
        type: "text",
        readOnly: true,
      },
      {
        name: "mobile_number",
        label: "Mobile No.",
        type: "text",
        readOnly: true,
      },
      {
        name: "application_product_type",
        label: "Product Type",
        type: "select",
        options: _enum.LOAN_TYPES,
        readOnly: true,
      },
      {
        name: "lender_bank_name",
        label: "Bank Name",
        type: "select",
        options: [{ key: "SBI", label: "SBI" }],
        readOnly: true,
      },
      {
        name: "loan_amount",
        label: "Loan Amount",
        type: "number",
        readOnly: true,
      },
      {
        name: "loan_status",
        label: "Loan Status",
        type: "select",
        options: _enum.APPLICATION_STATUS,
        disabled: true,
      },
      {
        name: "application_status",
        label: "Application Status",
        type: "select",
        options: _enum.APPLICATION_STATUS_ALL,
        disabled: true,
      },
      {
        name: "loan_disbursed_amount",
        label: "Disb. Amount",
        type: "number",
        readOnly: true,
      },
      {
        name: "loan_disbursement_date",
        label: "Disb. Date",
        type: "date",
        // type: "text",
        readOnly: true,
      },
      {
        type: "section",
        label: "Payout Info:",
        divider: true,
        colspan: 24,
        align: "end",
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        type: "empty",
        colspan: 24,
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },

      // PAYOUT INFO FIELDS --------------------------------
      {
        label: "Payment Status",
        name: "connector_payout_status",
        type: "select",
        options: _enum.PAYOUT_STATUS,
        placeholder: "Please Enter",
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "connector_payout_pct",
        label: "Connector Payout %",
        type: "number",
        dynamicRules: (values) => {
          if (values.connector_payout_status === "PROCESSED") {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "connector_payout_amt",
        label: "Connector Payout Amt.",
        type: "text",
        readOnly: true,
        dynamicRules: (values) => {
          if (values.connector_payout_status === "PROCESSED") {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "connector_payout_tds_pct",
        label: "TDS %",
        type: "number",
        dynamicRules: (values) => {
          if (values.connector_payout_status === "PROCESSED") {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "connector_payout_tds_amt",
        label: "TDS Amt.",
        type: "number",
        readOnly: true,
        dynamicRules: (values) => {
          if (values.connector_payout_status === "PROCESSED") {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "net_connector_payout_amt",
        label: "Net Payout Amt",
        type: "number",
        readOnly: true,
        dynamicRules: (values) => {
          if (values.connector_payout_status === "PROCESSED") {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "connector_payout_dtm",
        label: "Payment Date",
        type: "date",
        dynamicRules: (values) => {
          if (values.connector_payout_status === "PROCESSED") {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "bank_payout_pct",
        label: "Bank Payout %",
        type: "number",
        dynamicRules: (values) => {
          if (values.connector_payout_status === "PROCESSED") {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "bank_payout_amt",
        label: "Bank Payout Amt.",
        type: "number",
        required: true,
        dynamicRules: (values) => {
          if (values.connector_payout_status === "PROCESSED") {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "bank_payout_receive_dtm",
        label: "Bank Payout Received Date",
        type: "date",
        dynamicRules: (values) => {
          if (values.connector_payout_status === "PROCESSED") {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "remarks",
        label: "Remarks",
        type: "textarea",
        colspan: 24,
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
    ],
  };
  const dependencies = {
    // PAYOUT INFO CALCULATION
    // 1. Bank Payout Amt = (Bank Payout) % of  Disb. Amount
    // 2. Digirep Payout Amt = (Digi Team Member Payout) % of Disb. Amount
    // 3. Net Payout Amt = Digirep Payout Amt - (TDS) % of  Digirep Payout Amt

    // Handle Connector Payout Amount Calculation
    connector_payout_pct: (percent, allValues) => {
      let disbursedAmt = Number(allValues.loan_disbursed_amount);
      let connectorPayoutAmt = (percent / 100) * disbursedAmt;
      return {
        valueUpdates: {
          connector_payout_amt: connectorPayoutAmt,
        },
      };
    },
    // Handle TDS and Payout Amount Calculation
    connector_payout_tds_pct: (tdsPct, allValues) => {
      let tdspct = Number(tdsPct);
      let netPayout, tdsAmount;
      let connectorPayoutAmt = Number(allValues.connector_payout_amt);
      if (tdspct === 0) {
        netPayout = 0;
        tdsAmount = 0;
      } else {
        tdsAmount = (tdspct / 100) * connectorPayoutAmt;
        netPayout = connectorPayoutAmt - connectorPayoutAmt * (tdspct / 100);
      }
      return {
        valueUpdates: {
          connector_payout_tds_amt: tdsAmount,
          net_connector_payout_amt: netPayout,
        },
      };
    },
    // Handle Bank Payout Percentage Calculation
    bank_payout_pct: (bankPayoutPct, allValues) => {
      let bankpct = Number(bankPayoutPct);
      let disbursedAmt = Number(allValues.loan_disbursed_amount);

      let amount = disbursedAmt;
      let percent = bankpct;
      let bankPayoutAmnt = (percent / 100) * amount;
      return {
        valueUpdates: {
          bank_payout_amt: bankPayoutAmnt,
        },
      };
    },
  };

  const {
    appform,
    state: modalState,
    openModal,
    closeModal,
    handleValuesChange,
  } = useModalForm(modalConfigs, dependencies);

  const openApplicationModal = () => {
    let defaultValues = {
      application_status: "DISBURSED",
      connector_payout_status: "PROCESSED",
    };
    openModal("applicationLoan", "add", "Add Application", defaultValues);
  };

  const view = (record) => {
    let defaultValues = {
      ...record,
      connector_payout_status: "PENDING",
    };
    openModal("payoutInfo", "view", "View Application", defaultValues);
  };

  const edit = (record) => {
    setApplId(record.application_id);
    let defaultValues = {
      ...record,
      connector_payout_status: "PROCESSED",
    };
    openModal("payoutInfo", "edit", "Edit Application", defaultValues);
  };

  const handleAppModalSubmit = async (data) => {
    if (modalState.mode === "edit" && modalState.type === "payoutInfo") {
      let payload = {
        application_id: applId,
        connector_payout_pct: data?.connector_payout_pct,
        connector_payout_amt: data?.connector_payout_amt,
        connector_payout_tds_pct: data?.connector_payout_tds_pct,
        connector_payout_tds_amt: data?.connector_payout_tds_amt,
        net_connector_payout_amt: data?.net_connector_payout_amt,
        connector_payout_status: data?.connector_payout_status,
        connector_payout_dtm: data?.connector_payout_dtm,
        bank_payout_pct: data?.bank_payout_pct,
        bank_payout_amt: data?.bank_payout_amt,
        bank_payout_receive_dtm: data?.bank_payout_receive_dtm,
        remarks: data?.remarks,
      };
      const res = await props.apis.apiAdminAddApplicationPayoutInfo(
        payload,
        applId
      );
      if (res) {
        swal2.fire({
          title: "Lead updated and sent for payout successfully.",
          icon: "success",
          iconColor: "#234C9B",
          confirmButtonText: "Ok",
          timer: 4000,
        });
        closeModal();
        getData();
      }
    } else if (modalState.mode === "add") {
      const res = await props.apis.apiAddConnectorApplication(data);
      if (res) {
        swal2.fire({
          title: "Application added successfully.",
          icon: "success",
          iconColor: "#234C9B",
          confirmButtonText: "Ok",
          timer: 4000,
        });
        closeModal();
        getData();
      }
    }
  };

  const getData = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, ["page", "limit"]);

      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
      };
    } else {
      payload = {
        ...search,
        ...params,
      };
    }

    if (!isAdmin) {
      props.apis
        .apiGetApplicationPayoutInfo({
          ...payload,
          application_status: "SEND_FOR_PAYOUT",
        })
        .then(({ data, count }) => {
          setData(data);
          setRowcount(count);
          setIsFetching(false);
        });
    } else {
      props.apis
        .apiGetApplicationPayoutInfo({
          ...payload,
          application_status: "SEND_FOR_PAYOUT",
        })
        .then(({ data, count }) => {
          setData(data);
          setRowcount(count);
          setIsFetching(false);
        });
    }
  };

  const onSearch = (data, reset) => {
    if (Object.keys(data).length === 0) {
      setSearch({
        ...data,
        ...search,
      });
      getData(data, reset);
    } else {
      setSearch({
        ...data,
        ...search,
      });
      getData(data, reset);
    }
  };

  const onPageChange = (pageData) => {
    setSearch({
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    });
  };
  // ----------------------------------------------------------------
  const downloadExcel = async () => {
    let payload = {
      application_status: "SEND_FOR_PAYOUT",
    };
    props.apis.apiExportApplicationPayout(payload).then(async (res) => {
      if (res) {
        let data = await res;
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `Connector_Applications_Details.xlsx`);
        link.click();
      }
    });
  };
  // ----------------------------------------------------------------
  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <div className="d-flex align-items-center justify-content-end mb-3 float_top_lg">
        <PendingSearch
          onSearch={(...arg) => onSearch(...arg)}
          openApplicationModal={openApplicationModal}
          downloadExcel={(...args) => downloadExcel(...args)}
        />
      </div>
      <AppTable
        data={data}
        columns={columns}
        onChange={(...arg) => onPageChange(...arg)}
        total={rowcount}
        reorder={true}
        viewAction={(e) => view(e)}
        {...(isAdmin
          ? { editable: true, editAction: (e) => edit(e) }
          : { editable: false })}
        deletable={false}
        loading={isFetching}
      ></AppTable>

      <AppFormModal
        form={appform}
        title={modalState.title}
        open={modalState.open}
        onValuesChange={handleValuesChange}
        onClose={closeModal}
        fields={modalState.fields}
        onSubmit={handleAppModalSubmit}
        mode={modalState.mode}
        persona={props?.$store?.user?.role}
      />
    </>
  );
};

export default constore(Pending);
